import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import Points from './components/points/Points';
import Benefits from './components/benefits/Benefits';
import Exchange from './components/exchange/Exchange';
import { getBankCategories } from '../../../redux/actions/BankActions';
import {
  POINTS_ROUTE,
  BENEFITS_ROUTE,
  EXCHANGE_ROUTE,
} from '../../../constants/Routes';
import useStyles from './styles';

const MyPoints = ({ ...props }) => {
  const { path, mobile } = props;
  const dispatch = useDispatch();
  const { points, categories, pointsStatus } = useSelector(
    (state) => state.bankReducer,
  );
  const classes = useStyles();

  useEffect(() => {
    dispatch(getBankCategories());
  }, []);

  return (
    <Box className={classes.container}>
      {path === POINTS_ROUTE && (
        <Points
          categories={categories}
          points={points}
          mobile={mobile}
          pointsStatus={pointsStatus}
        />
      )}
      {path === BENEFITS_ROUTE && (
        <Benefits
          mobile={mobile}
          points={Object.entries(points).length > 0 ? Number(points.Points) : 0}
        />
      )}
      {path === EXCHANGE_ROUTE && (
        <Exchange mobile={mobile} categories={categories} />
      )}
    </Box>
  );
};

MyPoints.propTypes = {
  path: PropTypes.string,
  mobile: PropTypes.bool,
};

export default MyPoints;
